import { render, staticRenderFns } from "./BindCardActions.vue?vue&type=template&id=1ca83da6&scoped=true&"
import script from "./BindCardActions.vue?vue&type=script&lang=js&"
export * from "./BindCardActions.vue?vue&type=script&lang=js&"
import style0 from "./BindCardActions.vue?vue&type=style&index=0&id=1ca83da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca83da6",
  null
  
)

export default component.exports